import { render, staticRenderFns } from "./RedeemHistory.vue?vue&type=template&id=9ccea862&scoped=true&"
import script from "./RedeemHistory.vue?vue&type=script&lang=js&"
export * from "./RedeemHistory.vue?vue&type=script&lang=js&"
import style0 from "./RedeemHistory.vue?vue&type=style&index=0&id=9ccea862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccea862",
  null
  
)

export default component.exports